module.exports = function () {
  this.app.$on('updateRsvp', event => {
    this.app.leg1 = event.leg1
    this.app.leg2 = event.leg2
  })

  this.app.$on('gaTracking', event => {
    // if (this.app.$ga) {
    //   this.app.$ga.page(event)
    // }
  })
}



// WEBPACK FOOTER //
// ./src/events/rsvp.js